import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Mail, MessageCircle, HelpCircle, Sparkles } from 'lucide-react';
import Navigation from '../components/Navigation';

const Contact = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen-safe bg-gradient-to-b from-emerald-50 to-white flex flex-col">
      {/* Header */}
      <Navigation showFeedback={false} />

      {/* Contact Content */}
      <div className="container mx-auto px-4 py-12 max-w-4xl flex-1">
        <div className="text-center mb-8">
          <h1 className="text-3xl sm:text-4xl font-bold mb-4 text-gray-900">Contact Us</h1>
          <p className="text-lg text-gray-600">
            Have questions or need support? We&apos;re here to help.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {/* Support Email */}
          <Card>
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <Mail className="h-5 w-5 text-emerald-600" />
                Email Support
              </CardTitle>
              <CardDescription>
                Get help via email
              </CardDescription>
            </CardHeader>
            <CardContent>
              <p className="text-gray-600 mb-4">
                For general inquiries, support, or questions about Celey:
              </p>
              <a
                href="mailto:celeyapp@gmail.com"
                className="text-lg font-semibold text-emerald-600 hover:text-emerald-700 break-all"
              >
                celeyapp@gmail.com
              </a>
              <p className="text-sm text-gray-500 mt-4">
                We typically respond within 24-48 hours
              </p>
            </CardContent>
          </Card>

          {/* What We Help With */}
          <Card>
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <MessageCircle className="h-5 w-5 text-emerald-600" />
                What We Can Help With
              </CardTitle>
              <CardDescription>
                Topics we cover
              </CardDescription>
            </CardHeader>
            <CardContent>
              <ul className="space-y-2 text-gray-600">
                <li className="flex items-start gap-2">
                  <span className="text-emerald-600 mt-1">•</span>
                  <span>Account and profile issues</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-emerald-600 mt-1">•</span>
                  <span>Booking and inquiry questions</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-emerald-600 mt-1">•</span>
                  <span>Payment and billing support</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-emerald-600 mt-1">•</span>
                  <span>Technical issues</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-emerald-600 mt-1">•</span>
                  <span>Service provider listing questions</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-emerald-600 mt-1">•</span>
                  <span>Feature requests and feedback</span>
                </li>
              </ul>
            </CardContent>
          </Card>
        </div>

        {/* FAQ Section Redirect */}
        <Card className="mt-6 bg-emerald-50 border-emerald-100">
          <CardContent className="text-center py-8">
            <HelpCircle className="h-12 w-12 text-emerald-600 mx-auto mb-4" />
            <h3 className="text-xl font-bold text-gray-900 mb-2">
              Looking for answers?
            </h3>
            <p className="text-gray-600 mb-4">
              Check out our FAQs for quick answers to common questions.
            </p>
            <Button
              onClick={() => navigate('/faqs')}
              className="bg-emerald-600 hover:bg-emerald-700"
            >
              View FAQs
            </Button>
          </CardContent>
        </Card>
      </div>
      
      {/* Simple Footer */}
      <footer className="bg-gray-900 text-white py-8 mt-auto">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="flex items-center space-x-2">
              <Sparkles className="h-5 w-5 text-emerald-400" />
              <span className="text-xl font-bold">Celey</span>
            </div>
            <div className="flex items-center gap-6">
              <button
                onClick={() => navigate('/faqs')}
                className="text-gray-400 hover:text-white transition-colors text-sm"
              >
                FAQs
              </button>
              <button
                onClick={() => navigate('/browse')}
                className="text-gray-400 hover:text-white transition-colors text-sm"
              >
                Browse
              </button>
            </div>
            <div className="text-gray-400 text-sm text-center md:text-right">
              <p>© 2025 Celey</p>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Contact;
